import type { ReactNode } from "react";

import {
  CalendarPanelWidget,
  DailyPnLChartWidget,
  DrawdownChartWidget,
  EquityCurveChartWidget,
  KpiAvgPnlWidget,
  KpiProfitFactorWidget,
  KpiTotalPnlWidget,
  KpiWinRateWidget,
  StreakWidget,
  TradesPanelWidget,
  WinsLossesChartWidget,
} from "./components";
import type { WidgetType } from "./types";

export function renderWidget(type: WidgetType): ReactNode {
  switch (type) {
    case "kpi_total_pnl":
      return <KpiTotalPnlWidget />;
    case "kpi_win_rate":
      return <KpiWinRateWidget />;
    case "kpi_profit_factor":
      return <KpiProfitFactorWidget />;
    case "kpi_avg_pnl":
      return <KpiAvgPnlWidget />;
    case "chart_wins_losses":
      return <WinsLossesChartWidget />;
    case "chart_equity_curve":
      return <EquityCurveChartWidget />;
    case "chart_daily_pnl":
      return <DailyPnLChartWidget />;
    case "chart_drawdown":
      return <DrawdownChartWidget />;
    case "panel_trades":
      return <TradesPanelWidget />;
    case "panel_calendar":
      return <CalendarPanelWidget />;
    case "panel_streak":
      return <StreakWidget />;
  }
}
